



















































import { Vue, Component } from 'vue-property-decorator'
import LayerWrapper from '@/orrm/wrapper/layer'
import { context, search } from '@/store/modules'
import LayerCard from '@/components/LayerCard.vue'
import ButtonSheet from '@/components/ButtonSheet.vue'
import ScrollList from '@/components/ScrollList.vue'
import BigInfo from '@/components/BigInfo.vue'
import ContextWrapper from '@/orrm/wrapper/context'
import { Actualite } from '@/orrm/model/actualite'
import { InfoReglementation } from '@/orrm/model/info-reglementation'
import { Entity } from '@/orrm/model/entity'
import ActuFilterForm from '@/components/LayerFilterForms/ActuFilterForm.vue'
import InfosFilterForm from '@/components/LayerFilterForms/InfosFilterForm.vue'
import EntityFilterForm from '@/components/LayerFilterForms/EntityFilterForm.vue'
import { EntityType } from '@/orrm/model/entity-type'
import { InfoBundle } from '@/orrm/model/info-bundle'
import { Departement } from '@/orrm/model/departement'

@Component({
  components: {
    EntityFilterForm,
    InfosFilterForm,
    ActuFilterForm,
    BigInfo,
    LayerCard,
    ButtonSheet,
    ScrollList
  }
})
export default class LayersList extends Vue {
  get actuTags (): string[] {
    const tags = [
      ...search.actuCriterias.countries.map((country: 'ITA' | 'FRA') => country === 'ITA' ? 'Italie' : 'France'),
      ...search.actuCriterias.departements.map((departement: Departement) => departement.name)
    ]

    if (search.actuCriterias.phenomene) {
      tags.push(search.actuCriterias.phenomene.name)
    }

    if (search.actuCriterias.year) {
      tags.push(`${search.actuCriterias.year}`)
    }
    return tags
  }

  get infosTags (): string[] {
    return search.infoCriterias.bundles.map((bundle: InfoBundle) => bundle.label)
  }

  get entitiesTags (): string[] {
    return search.entityCriterias.types.map((type: EntityType) => type.name)
  }

  get actuLayerId () {
    return Actualite.layerId
  }

  get infosLayerId () {
    return InfoReglementation.layerId
  }

  get entitiesLayerId () {
    return Entity.layerId
  }

  get showAll (): boolean {
    return this.layers.every((layer: LayerWrapper) => layer.enabled)
  }

  set showAll (value: boolean) {
    this.layers.forEach((layer: LayerWrapper) => { layer.enabled = value })
  }

  get spacing (): number {
    return !context.hasActiveContext ? 96 : 38
  }

  get contextActivated (): boolean {
    return context.hasActiveContext
  }

  get originalContext (): ContextWrapper | null {
    if (context.activeContext) {
      return context.originalContexts.find((cw: ContextWrapper) => {
        if (context.activeContext) {
          return cw.model.uuid === context.activeContext.model.uuid
        }
        return false
      }) ?? null
    }
    return null
  }

  get layers (): LayerWrapper[] {
    if (context.activeContext) {
      return context.activeContext.layers
    }
    return []
  }

  set layers (value: LayerWrapper[]) {
    if (context.activeContext) {
      context.activeContext.layers = value
    }
  }

  getTags (layerId: string): string[] {
    if (layerId === Actualite.layerId) return this.actuTags
    if (layerId === InfoReglementation.layerId) return this.infosTags
    if (layerId === Entity.layerId) return this.entitiesTags
    return []
  }

  isFake (item: LayerWrapper): boolean {
    return item.model.layerType === 'fake'
  }

  resetContext () {
    if (context.activeContext) {
      context.resetContext(context.activeContext)
    }
  }

  isUnchanged (layer: LayerWrapper): boolean {
    if (this.originalContext) {
      return !!this.originalContext.layers.find((lw: LayerWrapper) => lw.model.uuid === layer.model.uuid)
    }
    return false
  }

  remove (layer: LayerWrapper) {
    if (context.activeContext) {
      for (let i = 0; i < context.activeContext.layers.length; i++) {
        if (context.activeContext.layers[i].model.uuid === layer.model.uuid) {
          context.activeContext.layers.splice(i, 1)
        }
      }
    }
  }
}
